import type { IScheduledEmailContentV2 } from '@/types/email.types';

export const defaultCustomizations: IScheduledEmailContentV2 = {
  title: { base: '', changed: '' },
  description: { base: '', changed: '' },
  cta: { base: '', changed: '' },
  salutation: { base: '', changed: '' },
  startIntro: { base: '', changed: '' },
  subject: { base: '', changed: '' },
  headingFont: '',
  bodyFont: '',
  headingImage: '',
  mainImage: '',
  backgroundColor: '',
  containerColor: '',
  accentColor: '',
  headingTextColor: '',
  bodyTextColor: '',
  secondaryAccentColor: '',
  secondaryBackgroundColor: '',
  buttonTextColor: '',
  campaignTitle: '',
  templateId: 'capri',
};
